<template>

  <div style="overflow: auto;">
    <div class="flex">
      <div>
        <div class="card text-white bg-secondary">
          <div class="card-header">
            Total ({{ job.pipeline.total }})
          </div>
          <div class="card-body">
            <div style="font-size: 2em">{{ job.pipeline.qualified }}</div>
            <div>{{ $t('Qualifieds') }}</div>
            <hr>
            <div v-html="$tc('n_disqualified', job.pipeline.disqualified, {count: job.pipeline.disqualified})"></div>
          </div>
        </div>
      </div>
      <div
        v-for="(stage, index) in job.pipeline.stages"
        :key="index">
        <div class="card">
          <div class="card-header">
            {{ stage.name }} ({{ stage.total }})
          </div>
          <div class="card-body">
            <div style="font-size: 2em">{{ stage.qualified }}</div>
            <div>{{ $t('Qualifieds') }}</div>
            <hr>
            <div v-html="$tc('n_disqualified', stage.disqualified, {count: stage.disqualified})"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'JobReportPipeline',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex {
    display: flex;
  }
  .flex > * {
    flex: 1 100px;
    min-width: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReportPipeline.vue